import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GraphsPage } from '@/features/editor/graphs-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * La page courante vit dans l'URL : une capture ou un lien pointe sur la bonne page.
 * La première page ne l'écrit pas (`?page=0` ne dit rien de plus que l'URL nue).
 */
export const Route = createFileRoute('/$tenant/editor/')({
  validateSearch: (search: Record<string, unknown>): { page?: number } => {
    const page = Number(search['page']);
    return Number.isInteger(page) && page > 0 ? { page } : {};
  },
  component: GraphsRoute,
});

function GraphsRoute() {
  const { tenant } = Route.useParams();
  const { page = 0 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell tenantId={tenant} activeItem="editor" crumbs={[{ label: t('nav.items.editor') }]}>
      <GraphsPage
        tenantId={tenant}
        page={page}
        onPageChange={(next) => void navigate({ search: next > 0 ? { page: next } : {}, replace: true })}
      />
    </ConsoleShell>
  );
}
